import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert, Job } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';

interface DownloadJobProps {
    jobId: string | undefined;
    fileType: string | undefined;
}

const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<Job[], any>> => {
    const headers = getDefaultHeaders(token);

    const customHeaders: any = {
        ...withHeaders(headers),
        responseType: 'arraybuffer',
    };

    return axiosInstance().get(url, customHeaders);
};

export const useDownloadJob = ({
    jobId,
}: DownloadJobProps): UseQueryResult<AxiosResponse<Job[], any>, unknown> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useQuery(
        `job-download-${jobId}`,
        async () => getQueryData(`/jobs/download/${jobId}`, getToken()),
        {
            enabled: false,
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ??
                    `Unable to download file with id: ${jobId}`;

                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
